import React, { useEffect, useState } from 'react';
import styles from './PageLoader.module.css';

const PageLoader = () => {
  const [visible, setVisible] = useState(true);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setExiting(true), 1800);
    const timer2 = setTimeout(() => setVisible(false), 2400);
    return () => { clearTimeout(timer1); clearTimeout(timer2); };
  }, []);

  if (!visible) return null;

  return (
    <div className={`${styles.loader} ${exiting ? styles.exit : ''}`}>
      <div className={styles.content}>
        <div className={styles.logo}>
          {'VIN FLY'.split('').map((l, i) => (
            <span key={i} className={styles.logoLetter} style={{ animationDelay: `${i * 0.08}s` }}>
              {l === ' ' ? '\u00A0' : l}
            </span>
          ))}
        </div>
        <div className={styles.bar}>
          <div className={styles.barFill} />
        </div>
        <p className={styles.sub}>BUILD YOUR CAREER IN AIRLINE...</p>
      </div>
    </div>
  );
};

export default PageLoader;
